module.exports = __webpack_public_path__ + "static/img/his-radio.47dfa670.png";